<template>
  <div class="mb-5">
    <div class="columns">
      <div class="column is-12 is-10-desktop is-offset-2-desktop">
        <div class="columns is-mobile is-multiline is-justify-content-flex-end">
          <div class="column is-6-mobile is-6-tablet is-4-desktop">
            <b-input
              :value="$route.query.keyword"
              type="text"
              placeholder="Numéro, Serial"
              :icon-right="$route.query.keyword ? 'close-circle' : ''"
              icon-right-clickable
              @keyup.native.enter="fetch({ ...$route.query, keyword: $event.target.value })"
              @icon-right-click="fetch({ ...$route.query, keyword: undefined })"
            />
          </div>
          <div class="column is-6-mobile is-6-tablet is-4-desktop">
            <b-select
              :value="$route.query.availability"
              placeholder="Choisir un status"
              icon="history"
              expanded
              @input="fetch({ ...$route.query, availability: $event })"
            >
              <option :value="null">Choisir un status</option>
              <option
                v-for="availability in Object.keys(availabilities)"
                :key="availability"
                :value="availability"
              >
                {{ availabilities[availability] }}
              </option>
            </b-select>
          </div>
          <div class="column is-6-mobile is-6-tablet is-4-desktop">
            <b-select
              :value="$route.query.wear"
              placeholder="Choisir une usure"
              icon="heart"
              expanded
              @input="fetch({ ...$route.query, wear: $event })"
            >
              <option :value="null">Choisir une usure</option>
              <option v-for="wear in wears" :key="wear.value" :value="wear.value">
                {{ wear.label }}
              </option>
            </b-select>
          </div>
          <div class="column is-6-mobile is-6-tablet is-4-desktop">
            <b-select
              :value="$route.query.owner"
              placeholder="Choisir un propriétaire"
              icon="user"
              expanded
              @input="fetch({ ...$route.query, owner: $event })"
            >
              <option :value="null">Choisir un propriétaire</option>
              <option v-for="owner in owners" :key="owner" :value="owner">
                {{ capitalize(owner) }}
              </option>
            </b-select>
          </div>
          <div v-show="showClearFilterButton" class="column is-12 has-text-right pt-0">
            <b-button class="is-small" type="is-text" @click="fetch({})">
              Supprimer tous les filtres
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { capitalize } from '@helpers/capitalize'
import { AVAILABILITIES } from '@constants/tracker/availability.js'
import { OWNERS } from '@constants/tracker/owner.js'
import { WEARS } from '@constants/tracker/wear.js'

export default {
  name: 'ListNeyosTrackersFilter',

  created() {
    this.owners = OWNERS
    this.availabilities = AVAILABILITIES
    this.wears = WEARS
  },

  computed: {
    showClearFilterButton() {
      return Object.values(this.$route.query).filter((v) => v).length > 0
    },
  },

  methods: {
    async fetch(query) {
      this.$router.push({ query })
    },

    capitalize(value) {
      return capitalize(value)
    },
  },
}
</script>
